import React from "react";
import { usePrinterExtraStore } from "../../state/storePrinterExtra";
import PrinterInputs from "./PrinterInputs";

type Props = {};

const PrinterMiddleLogoInput = (props: Props) => {
  const { printer_logo, printer_logo_url } = usePrinterExtraStore(
    (state) => state
  );
  return (
    <div className="p-2 flex-1">
    <PrinterInputs
      value={printer_logo || printer_logo_url}
      label="printer_logo"
      type="text"
    />
  </div>
  );
};

export default PrinterMiddleLogoInput;
